module.exports = __webpack_public_path__ + "static/media/beep.53d97f3b.mp3";